import { CategoryInterface } from 'types';

export const moveConsultationToFirst = (
  categories: CategoryInterface[]
): CategoryInterface[] => {
  const isCategoryExist = categories.length > 0;

  if (isCategoryExist) {
    const consultationIndex = categories.findIndex(
      (category) => category.name.toLowerCase() === 'consultation'
    );
    if (consultationIndex !== -1) {
      const updatedCategories = [...categories];
      const consultationCategory = updatedCategories.splice(
        consultationIndex,
        1
      )[0];
      updatedCategories.unshift(consultationCategory);
      return updatedCategories;
    }
  }
  return categories;
};
